import { assessmentsHandlers } from './assessments';
import { authHandlers } from './auth';
import { badgesHandlers } from './badges';
import { batchSelectionHandlers } from './batch-selection';
import { bhanzuBuddyHandlers } from './bhanzu-buddy';
import { calendarHandlers } from './calendar';
import { enrollmentsHandlers } from './enrollments';
import { invoiceLinkHandlers } from './invoice-link';
import { moduleReportsHandlers } from './module-reports';
import { modulesHandlers } from './modules';
import { parentConnectBookingHandlers } from './parent-connect-booking';
import { parentConnectCancelRescheduleHandlers } from './parent-connect-cancel-reschedule';
import { parentConnectEditRequestHandlers } from './parent-connect-edit-request';
import { parentConnectRespondHandlers } from './parent-connect-respond';
import { pcFeedbackHandlers } from './pc-feedback';
import { profilesHandlers } from './profiles';
import { sessionsHandlers } from './sessions';
import { userHandlers } from './user';
import { waitlistHandlers } from './waitlist-status';

export const handlers = [
  ...authHandlers,
  ...badgesHandlers,
  ...bhanzuBuddyHandlers,
  ...userHandlers,
  ...sessionsHandlers,
  ...modulesHandlers,
  ...calendarHandlers,
  ...assessmentsHandlers,
  ...moduleReportsHandlers,
  ...waitlistHandlers,
  ...batchSelectionHandlers,
  ...invoiceLinkHandlers,
  ...enrollmentsHandlers,
  ...profilesHandlers,
  ...pcFeedbackHandlers,
  ...parentConnectBookingHandlers,
  ...parentConnectRespondHandlers,
  ...parentConnectEditRequestHandlers,
  ...parentConnectCancelRescheduleHandlers,
];
